import { LOGIN_STATUS, MEMBER_ID, MEMBER_TYPE, ACCOUNT_TYPE, ACCOUNT_ID } from "@/src/utils/constants/cookie-keys";
import { setCookie, deleteCookie } from "helpers/cookie";

export const setUserSessionCookies = (userData) => {
  if (!userData) return;

  const { id = "", accountId = "", accountType = "", role = "" } = userData || {};

  const cookieUserType = accountType === "CORPORATE" ? "customer" : "user";

  setCookie(LOGIN_STATUS, "true");
  setCookie(MEMBER_TYPE, cookieUserType);
  setCookie(MEMBER_ID, id);

  const accountTypeMapping = {
    ADMIN: "admin",
    ADVISOR: "danisman",
    DEFAULT: "danisman",
  };

  if (accountType === "CORPORATE") {
    const mappedAccountType = accountTypeMapping[role] || accountTypeMapping.DEFAULT;
    setCookie(ACCOUNT_TYPE, mappedAccountType, 9999);
    setCookie(ACCOUNT_ID, accountId, 9999);
  } else {
    setCookie(ACCOUNT_TYPE, "bireysel", 9999);
  }
};

export const clearUserSessionCookies = () => {
  const cookies = [MEMBER_TYPE, MEMBER_ID, ACCOUNT_TYPE, ACCOUNT_ID];

  setCookie(LOGIN_STATUS, "false", 9999);

  cookies.forEach((cookieName) => {
    deleteCookie(cookieName);
  });
};
